import React from "react";

export const Footer = (props) => {
return (
    <div id="footer">
      <div className="container text-center">
        <p>{props.data ? props.data.copyright : "© 2025 Reel Seven Organizer Design by Dani Pamungkas"}</p>
      </div>
    </div>
  );
};
